module.exports = __webpack_public_path__ + "img/kolor-2-14.9e665fc8.jpg";